var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"greybox"},[_c('h1',[_vm._v("What you need to do next...")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.selectedOptionInstructions)}}),_c('button',{staticClass:"button mt-3",on:{"click":function($event){return _vm.handleCancelClick()}}},[_vm._v("OK")])])
}
var staticRenderFns = []

export { render, staticRenderFns }